export const apiBaseUrl = `${window.location.protocol}//${window.location.host}`;

export const getEnvironment = (): 'prod' | 'qa' | 'test' | 'dev' => {
  switch (window.location.host) {
    case 'forms.airwis.com': return 'prod';
    case 'forms-qa.airwis.com': return 'qa';
    case 'forms-test.airwis.com': return 'test';
    default: return 'dev';
  }
};
